// Function to create a preview card for a file
export function createPreviewCard(file, removeCallback) {
  const template = getTemplate();
  if (!template) return null;

  const fragment = cloneTemplateContent(template);
  const card = extractCardFromFragment(fragment);
  if (!card) return null;

  populateCardDetails(card, file);
  attachViewButtonListener(card, file);
  attachRemoveButtonListener(card, file, removeCallback);

  return card;
}

// Function to update the preview container with new cards
export function updatePreviews(previewContainer, files, removeCallback) {
  const fragment = document.createDocumentFragment();

  [...files].forEach((file) => {
    const card = createPreviewCard(file, removeCallback);
    if (card) fragment.appendChild(card);
  });

  previewContainer.replaceChildren(fragment);
}

// Helper Functions
function getTemplate() {
  const template = document.getElementById("preview-template");
  if (!template) {
    console.error("Template not found");
    return null;
  }
  return template;
}

function cloneTemplateContent(template) {
  return template.content.cloneNode(true);
}

function extractCardFromFragment(fragment) {
  const card = fragment.querySelector(".preview-card");
  if (!card) {
    console.error("Preview card not found in template");
    return null;
  }
  return card;
}

function populateCardDetails(card, file) {
  const fileNameElement = card.querySelector(".name");
  if (fileNameElement) {
    fileNameElement.textContent = file.name;
  } else {
    console.error("File name element not found in template");
  }
}

function attachViewButtonListener(card, file) {
  const viewButton = card.querySelector(".actions .dc-eye").closest("button");
  if (viewButton) {
    viewButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.open(URL.createObjectURL(file), "_blank");
    });
  } else {
    console.error("View button not found in template");
  }
}

function attachRemoveButtonListener(card, file, removeCallback) {
  const removeButton = card.querySelector(".actions .dc-xmark").closest("button");
  if (removeButton) {
    removeButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      card.remove();
      if (removeCallback) {
        removeCallback(file);
      }
    });
  } else {
    console.error("Remove button not found in template");
  }
}
